module.exports = __webpack_public_path__ + "files/a042c637570ebc7d2089c64994e877b0.png";